import { create } from "zustand";

export const useI18nStore = create((set, get) => ({
  currentLanguage: "cs",
  translations: {},

  setLanguage: (language) => set({ currentLanguage: language }),

  setTranslations: (translations) => set({ translations }),

  t: (key, params = {}) => {
    const state = get();
    const { currentLanguage, translations } = state;

    if (!translations[currentLanguage]) {
      console.warn(`No translations found for language: ${currentLanguage}`);
      return key;
    }

    // Navigate nested object using dot notation
    const keys = key.split(".");
    let translation = translations[currentLanguage];

    for (const k of keys) {
      if (translation && typeof translation === "object" && k in translation) {
        translation = translation[k];
      } else {
        console.warn(`Missing translation for key: ${key} in language: ${currentLanguage}`);
        return key;
      }
    }

    if (typeof translation !== "string") {
      console.warn(`Translation for key: ${key} is not a string in language: ${currentLanguage}`);
      return key;
    }

    // Replace parameters in the translation
    let result = translation;
    Object.keys(params).forEach((param) => {
      result = result.replace(new RegExp(`\\{${param}\\}`, "g"), params[param]);
    });

    return result;
  },
}));
